export default {
  selectedClassId: 'all',

  managingClasses: {},

  isClassStudent: null,

  joinedClasses: [],
};
